module.exports = {
	endpoint: 'https://trivia.computer',
	donationsUrl: 'https://pillarist.com/donations.json',
	enableTestUsers: false,
	testJwtUser: false,
	testJwtAdmin: false
}
